const origin = process.env.REACT_APP_BACKEND_URL;
if (!origin) throw new Error('REACT_APP_BACKEND_URL is required');

export async function postApi(path, body) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 20000);
  try {
    const response = await fetch(`${origin}/api${path}`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body), signal: controller.signal,
    });
    const data = await response.json();
    if (!response.ok) {
      const message = Array.isArray(data.detail) ? data.detail.map(e => e.msg).join(' ') : data.detail;
      throw new Error(message || 'Please try again shortly.');
    }
    return data;
  } catch (error) {
    if (error.name === 'AbortError' || error instanceof TypeError) {
      throw new Error('We couldn’t connect. Please check your connection and try again.');
    }
    throw error;
  } finally { clearTimeout(timeout); }
}